import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface CoverLetterReturn {
  mode: ComputedRef<InputMode>
  coverLetter: ComputedRef<File | File[] | null>
  setCoverLetter: (file: File | File[] | null) => void
}

export const useCoverLetter = (): CoverLetterReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.coverLetter))
  const coverLetter = computed(() => tutorApplicationStore.coverLetter)

  const setCoverLetter = (file: File | File[] | null) => {
    tutorApplicationStore.setCoverLetter(file)
  }

  return {
    mode,
    coverLetter,
    setCoverLetter,
  }
}
